import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ZonaExtendidaCPEdit } from "./edit";
const EditModal = ZonaExtendidaCPEdit;
type Entity = models.ZonaExtendidaCP;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "CP", cell: x => ({ data: x.CP }) },
    ];
}

/**Establece las propiedades de descripcion para ser mostradas correctamente en el listado */
async function setDescripciones(x: Entity) : Promise<Entity> {
    return x;
}

/**
* Listado de ZonaExtendidaCP
*/
class ZonaExtendidaCPListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    onAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    onEdit = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    onBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar CP?", "" + item.CP);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <kea.Panel title="Códigos postales" buttons={[
                <kea.AgregarButton onClick={this.onAgregar} />
            ]}>
                <kea.Grid2 items={this.props.value} columnas={cols}  />
                {this.modals.component}
            </kea.Panel>
        );
    }
}
export const ZonaExtendidaCPList = kea.mapProps(componentToRx(ZonaExtendidaCPListNoRx), x => ({...x, value: x.value || []}));



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/zonaextendida/edit/cps/index.tsx